import { GenerationSection } from '../../types/articleGeneration';

/** Assemble the article markdown from the persisted sections array. */
export function buildMarkdown(h1: string, sections: GenerationSection[]): string {
  const parts: string[] = [`# ${h1}`];
  for (const section of [...sections].sort((a, b) => a.index - b.index)) {
    if (section.heading) parts.push(`## ${section.heading}`);
    if (section.body.trim()) parts.push(section.body.trim());
  }
  return parts.join('\n\n');
}
